<div class="comments-list">
    @if (comments().length === 0) {
        <div class="empty-comment-text">No comments yet</div>
    }
    @for (comment of comments(); track comment) {
        <div #commentContainer class="comment">
            <div class="comment-header">
                <div class="layout-vbox" style="width: 100%; overflow: hidden">
                    <b class="shrinkable-block" style="flex-shrink: 1">{{comment.createdBy}}</b>
                    <span class="shrinkable-block" style="flex-shrink: 10; font-size: 10px">
                        {{AppFormat.formatAnyAsDateTime(comment.createdAt)}}
                    </span>
                </div>

                <div class="layout-hbox" style="gap: 0; white-space: nowrap;">
                    @if (comment.editMode) {
                        <fluent-button class="tiny-width" appearance="subtle" title="Save" (click)="saveEditedText(commentContainer, comment)">
                            <i class="fat fa-save"></i>
                        </fluent-button>
                        <fluent-button class="tiny-width" appearance="subtle" title="Cancel" (click)="toggleEdit(comment)">
                            <i class="fat fa-cancel"></i>
                        </fluent-button>
                    } @else {
                        <fluent-button class="tiny-width" appearance="subtle" title="Edit" (click)="toggleEdit(comment)">
                            <i class="fat fa-pen"></i>
                        </fluent-button>
                    }
                    <fluent-button class="tiny-width" appearance="subtle" title="Delete" (click)="deleteComment(comment)">
                        <i class="fat fa-trash-xmark"></i>
                    </fluent-button>
                </div>

            </div>
            @if (comment.editMode) {
                <textarea class="comment-editor" [value]="comment.content" autofocus></textarea>
            } @else {
                <div class="comment-text markdown-output small-text" [innerHTML]="renderMarkdown(comment.content)"></div>
            }
        </div>
    }
    <div style="flex: 1;"></div>
    <div class="layout-hbox">
        <textarea #newComment class="comment-new" (input)="adjustTextareaHeight(newComment)"></textarea>
        <fluent-button class="tiny-width" appearance="subtle" title="Send" (click)="onSendNewComment(newComment)">
            <i class="fat fa-send"> </i>
        </fluent-button>
    </div>
</div>
